import Nav from './Nav'

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav/index.js